import StudentInformationContent from "./StudentInformationContent";

const StudentDetailComponent = ({ student, schoolId, trainingId, callback, link = "students", showHistory = true }) => {
  return (
    <div>
      <StudentInformationContent
        student={student}
        schoolId={schoolId}
        trainingId={trainingId}
        siblingLink={link}
        showStudentFileButton={false}
        showHistory={showHistory}
      />
    </div>
  );
};

export default StudentDetailComponent;
